import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleQuestionRegular from './chat-bubble-question-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChatBubbleQuestionRegular {...props} />;
}
SvgComponent.iconName = 'chatBubbleQuestionRegular';

export const ChatBubbleQuestionRegularIcon = svgIconWrapper(SvgComponent);
